module.exports = __webpack_public_path__ + "img/katarina_events_14.908e317b.jpg";